import React, { useState } from "react";

export default ({
  fieldName,
  placeholder,
  type,
  value,
  onValueChange,
}: any) => {
  const handleValueChange = (event: any) => {
    if (onValueChange) onValueChange(event.target.value);
  };
  return (
    <div>
      <div className=" e-field">{fieldName}</div>
      <div className="e-input">
        <input
          onChange={handleValueChange}
          value={value}
          type={type}
          placeholder={placeholder}
        ></input>
      </div>
    </div>
  );
};
